import { h } from 'preact';
import { Router } from 'preact-router';


// Code-splitting is automated for `routes` directory
import Kanda from '../routes/kanda';

const App = () => (
	<div id="app">
		<Router>
			<Kanda path="/" />
			<Kanda path="/:apr169/:apr139/:apr119/:apr0/:defaultSelectedAPR?/:backgroundColor?/:calculatorBackgroundColor?/:highlightColor?/:highlightTextColor?/:textColor?/:highlightBackgroundColor?/:controlsBackgroundColor?/:listBorderColor?/:companyName?/:outerTextColor?/:padding?" />
		</Router>
	</div>
)

export default App;
